<div class="collapsible-pane-header {{titleBold ? 'font-weight-bold' : 'font-weight-normal'}} {{hideContent ? 'closed' : 'opened'}} no-shadow"
         tooltip="{{(hideContent && showTooltip ? 'Click to reveal the hidden pane' : '') | translate}}"
         (click)="toggleContent()">
    <div class="{{ collapsibleLeft ? 'd-flex align-items-center' : 'd-flex justify-content-between align-items-center mr-1'}} {{disableTitleMargins ? '' : 'title--with-margins'}}">

        <i class="float-right"
           *ngIf="!hideContent && collapsibleLeft"
           class="fas fa-angle-up services-select__icon font-07"></i>
        <i class="float-right"
           *ngIf="hideContent && collapsibleLeft"
           class="fas fa-angle-down services-select__icon font-07"></i>



        <span>
            {{title | translate}}
            <span *ngIf="showHeaderBtn"
                  (click)="headerBtnAction();$event.stopPropagation();"
                  class="addBtn services-icon--add ml-2">
                {{showHeaderBtnText | translate}}
            </span>
        </span>

        <i class="float-right"
           *ngIf="!hideContent && !collapsibleLeft"
           class="fas fa-angle-up services-select__icon font-07"></i>
        <i class="float-right"
           *ngIf="hideContent && !collapsibleLeft"
           class="fas fa-angle-down services-select__icon font-07"></i>

        <i *ngIf="showVisibilityIcon" class="far {{ !isVisible ? 'fa-eye-slash' : 'fa-eye'}} services-select__icon font-07 ml-auto" (click)="toggleVisibility();"></i>

    </div>
</div>
<div [ngClass]="{'opened' : !hideContent}" class="row p-0 m-0 panel panel-content panel-shadow">
    <ng-content></ng-content>
</div>
